import { liveQuery } from 'dexie'

/**
 * A helper function to setup a live query for a dexie database.
 * Useful when mocking in unit tests.
 *
 * @param Function result - a function to call on db data
 * @param Function callback - a callback that runs after db's data set in the result has changed
 * @returns a subscription - Observable<T>
 */
export const dexieSubscriptionCallback = <T>(
  result: () => Promise<T>,
  callback: (databaseEntry: T) => void
) => {
  return liveQuery(async () => {
    return result()
  }).subscribe(databaseEntry => {
    callback(databaseEntry)
  })
}
